import { useCallback, useState } from 'react';

import { useUser } from '@/lib/auth';
import { Logger } from '@/lib/logs/logger';
import { LocalStorage } from '@/lib/storage/LocalStorage';

export const useBenchmarkSelection = (indicatorName: string) => {
  const { id: currentUserId } = useUser();
  const storageKey = `benchmark_selection_user_${currentUserId}`;

  const [selectedId, setSelectedId] = useState<string | null>(() => {
    const stored = LocalStorage.getItem(storageKey);
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        // eslint-disable-next-line security/detect-object-injection
        return parsed[indicatorName] || null;
      } catch (e) {
        Logger.error(`Failed to parse benchmark selection from LocalStorage: ${e}`);
        return null;
      }
    }
    return null;
  });

  const setSelection = useCallback(
    (newBenchmarkId: string | null) => {
      setSelectedId(newBenchmarkId);

      const stored = LocalStorage.getItem(storageKey);
      let selection: Record<string, string> = {};

      if (stored) {
        try {
          selection = JSON.parse(stored);
        } catch (e) {
          selection = {};
        }
      }

      if (newBenchmarkId) {
        // eslint-disable-next-line security/detect-object-injection
        selection[indicatorName] = newBenchmarkId;
      } else {
        // eslint-disable-next-line security/detect-object-injection
        delete selection[indicatorName];
      }

      LocalStorage.setItem(storageKey, JSON.stringify(selection));
    },
    [indicatorName, storageKey],
  );

  return [selectedId, setSelection] as const;
};
